import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {PermissionPersistRequest} from "../model/requests/permission-persist-request";
import {HttpUtils} from "../shared/http.utils";

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private readonly permissionsURL: string;


  constructor(private http: HttpClient) {
    this.permissionsURL = '/api/permissions';
  }

  createPermission(permissionData: PermissionPersistRequest): Observable<any> {
    const url: string = `${this.permissionsURL}`;
    return this.http.post<any>(url, permissionData);
  }

  editPermission(permissionData: PermissionPersistRequest): Observable<any> {
    const url: string = `${this.permissionsURL}/${permissionData.permissionUuid}`;
    return this.http.put<any>(url, permissionData);
  }

  getPermissions(): Observable<any> {
    const url: string = `${this.permissionsURL}`;
    return this.http.get<any>(url);
  }

  getPermission(permissionUuid: string): Observable<any> {
    const url: string = `${this.permissionsURL}/${permissionUuid}`;
    return this.http.get<any>(url);
  }

  deletePermissions(permissionUuids: any[]): Observable<any> {
    const url: string = `${this.permissionsURL}`;
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams());
    options.params["permissionUuids"] = permissionUuids;
    return this.http.delete<any>(url, options);
  }

  deletePermission(permissionUuid: string): Observable<any> {
    const url: string = `${this.permissionsURL}/${permissionUuid}/`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

}
